
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import AdminNavbar from "@/components/AdminNavbar";

export const NavigationWrapper = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isLoginPage = location.pathname === '/login' || location.pathname === '/auth';

  console.log("[NavigationWrapper] Current route:", location.pathname);
  console.log("[NavigationWrapper] Is admin route:", isAdminRoute);

  // Render only AdminNavbar for admin routes, and no navbar for login page
  return (
    <>
      {isAdminRoute ? <AdminNavbar /> : !isLoginPage && <Navbar />}
      {children}
    </>
  );
};
